export const MerchantIntentTesterLabelUpload = (data) => {
    var formdata = new FormData()
    formdata.append('id', data.id ? data.id : '')
    formdata.append('title', data.title ? data.title : '')
    formdata.append('product_url', data.product_url ? data.product_url : '')
    formdata.append('radio_label1', data.radio_label1 ? data.radio_label1 : '')
    formdata.append('radio_label2', data.radio_label2 ? data.radio_label2 : '')
    formdata.append('text_field_value', data.text_field_value ? data.text_field_value : '')
    formdata.append('text_field_title', data.text_field_title ? data.text_field_title : '')
    formdata.append('action', 'full')
    if (data.image) {
        formdata.append('banner_image', data.image.rawFile)
    }

    return formdata;
}